import React, { useState } from 'react';
import Nav from './Nav';
import { Link } from 'gatsby';
import logo from '../assets/img/logo.png';
export default function SideBar({ fullMenu }) {
  const [headerOpen, toggleHeader] = useState(false);
  return (
    <header id="header" className={`${fullMenu ? '' : 'alt'}`}>
      <div className={`${headerOpen ? 'is-menu-visible' : ' '}`}>
        <Link
          to="/"
          style={{ width: 60, margin: '100px 0 0 10px', border: 'none' }}
        >
          <img
            src={logo}
            alt=""
            style={{ width: 75, margin: '15px 0 0 0px', border: 'none' }}
          />
        </Link>
        <Nav onMenuToggle={() => toggleHeader(!headerOpen)} />
      </div>
    </header>
  );
}
